import { AppState } from '..'

export const selectActiveInvestment = (state: AppState) => state.betslip.workflow.activeInvestment

export const selectKeypadActiveValue = (state: AppState) => state.betslip.workflow.keypadActiveValue

export const selectAccountBalance = (state: AppState) => state.betslip.workflow.hostAccountBalance

export const selectIsBettingDisabled = (state: AppState) => state.betslip.workflow.isBettingDisabled

export const selectWorkflowStatus = (state: AppState) => state.betslip.workflow.currentStatus

export const selectApiErrorMessage = (state: AppState) => state.betslip.workflow.apiErrorMessage

export const selectIsHostUserLoggedIn = (state: AppState) =>
  state.betslip.workflow.isHostUserLoggedIn

export const selectVisibleBettingSection = (state: AppState) =>
  state.betslip.workflow.visibleBettingSection

export const selectCampaigns = (state: AppState) => state.betslip.workflow.userPromoData.campaigns

export const selectBonusBetBalance = (state: AppState) =>
  state.betslip.workflow.userPromoData.bonusBetBalance

export const selectBonusCashBalance = (state: AppState) =>
  state.betslip.workflow.userPromoData.bonusCashBalance

export const selectBonusCashCampaigns = (state: AppState) =>
  state.betslip.workflow.userPromoData.bonusCashCampaigns

export const selectIsBettingSectionExpanded = (state: AppState) =>
  state.betslip.workflow.isBettingSectionExpanded
